import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=dd5fa2ea&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/css/global/base.css?vue&type=style&index=0&id=dd5fa2ea&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5fa2ea",
  null
  
)

/* custom blocks */
import block0 from "@/components/administrations/locales/i18n-password-reset-overview.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fadministrations%2FPasswordReset.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports